import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl } from './shared-control-metadata';

import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';

const babylonResourceId = '/subscriptions/<subscriptionID>/resourceGroups/<resourceGroupName>/providers/Microsoft.Purview/accounts/<resourceName>';
const babylonResourceIdFormat = '\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.Purview\/accounts\/.+';
const babylonResourceIdErrorMessage = format(stringResources.InvalidResourceId, babylonResourceId);

export const babylonPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Purview/accounts',
    connectionSuffix: 'networking',
    resourceIdValidator: babylonResourceIdFormat,
    groupIdMetadata: {
        account: {
            linkedServiceType: 'Purview',
            groupId: 'account',
            iconClass: 'svg-purview',
            displayName: stringResources.PurviewLabel,
            controls: {
                creationControls: [{
                    type: 'radio-switch',
                    nested: 1,
                    label: stringResources.AccountSelectionMethodLabel,
                    description: stringResources.AzureSql_SelectMethodDescription,
                    options: azureResourceSelectMethodOptions,
                    isLabelVertical: true,
                    defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
                    cases: [
                        {
                            caseValue: 'azure',
                            children: [
                                {
                                    type: 'babylon-account-select',
                                    bind: {
                                        resourceID: 'privateLinkResourceId',
                                        managedResources: 'managedResourcePrivateLinkInfo'
                                    },
                                    fetchAccountKey: false,
                                    validators: {
                                        resourceID: [
                                            { type: 'required', errorMessage: '' }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            caseValue: 'manual',
                            children: [
                                getManualResourceIdControl(
                                    format(stringResources.PrivateEndpointResourceIdPlaceholder, babylonResourceId),
                                    babylonResourceIdFormat,
                                    babylonResourceIdErrorMessage)
                            ]
                        }
                    ]
                }],
                readonlyControls: getReadonlyControl(babylonResourceIdFormat, babylonResourceIdErrorMessage)
            }
        }
    },
    equippedWithManagedResource: true,
    managedResourceGroupIdInfo: {
        blob: stringResources.ModelName_StorageBlob,
        queue: stringResources.ModelName_StorageQueue,
        namespace: stringResources.ModelName_EventHubs_Namespace_DisplayText
    }
};
